import React, { useState } from 'react'
// import Box from '@mui/material/Box';
import Body from '../../layout/Body'
import { Autocomplete, Box, Breadcrumbs, Button, Card, Grid, IconButton, Link, Menu, MenuItem, Modal, CircularProgress, Paper, TextField, Typography, Avatar, Badge } from '@mui/material'
import { height, Stack } from '@mui/system'
import { useDispatch, useSelector } from 'react-redux';
import { uplodImageAction } from '../../redux/toolkit/image/uplodImage';
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup';
import { useForm } from 'react-hook-form';



const badgeSchema = yup.object({
    name: yup.string().required('Name is required'),
    reward_limit: yup.number().required(' is required.'),
    description: yup.string().required('Description  is required.'),
    image: yup.string().required('Image  is required.'),
    extra_coin:yup.string().required('Extra Coins Percentage Is Required')
}).required();




const AddBadge = ({ state, setState, onAddBadge }) => {

    const [image, setImage] = useState('')
    const dispatch = useDispatch()


    const handleClose = () => {
        setState(false)
    }

    const { register, setValue, setError, watch, handleSubmit, formState: { errors }, reset } = useForm({ resolver: yupResolver(badgeSchema) });


    const handleAddBadge = (data) => {
        onAddBadge(data);
        // setBadge({ name: '', reward_limit: '', description: '', image: '' });
        setState(false)
    }



    const handleImage = async (e) => {

        const formData = new FormData();

        const file = e.target.files[0];

        formData.append('file', file);

        let FileSize = Number(e.target.files[0].size / 1000);

        var _URL = window.URL || window.webkitURL;
        let img = new Image();
        var width, height;


        img.onload = async function () {
            width = this.width;
            height = this.height;
            if (FileSize > 5000) {
                return alert(`Image should be to under 50kb reupload image, Your file size is ${FileSize}`)
            }

            let uploadedImg = await dispatch(uplodImageAction(formData))
            const imgStr = uploadedImg?.payload?.data?.url;
            setImage(uploadedImg?.payload?.data?.url)
            setValue('image', imgStr)
            alert(`Image is Successfully Uploaded, Your file size is ${FileSize}`);

        };
        img.onerror = function () {
            alert("not a valid file: " + file.type);
        };
        img.src = _URL.createObjectURL(file);


    }



    return (
        <>

            <Body>
                <Modal
                    sx={{ overflow: 'scroll' }}
                    open={state}
                    onClose={handleClose}
                >
                    <Box className="modal_box">
                        <Card sx={{ width: 500, p: 5 }}>
                            <Typography variant="h5" sx={{ mb: 5 }} align="center">
                                Add Badge
                            </Typography>

                            <form sx={{ height: "auto" }} onSubmit={handleSubmit(handleAddBadge)}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Name"
                                            variant="outlined"
                                            placeholder="Name"
                                            {...register("name")}
                                            error={!!errors?.name?.message}
                                            helperText={errors?.name?.message}

                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Reward limit"
                                            variant="outlined"
                                            placeholder="Reward Limit"
                                            {...register("reward_limit")}
                                            error={!!errors?.reward_limit?.message}
                                            helperText={errors?.reward_limit?.message}

                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Description"
                                            variant="outlined"
                                            placeholder="Description"
                                            {...register("description")}
                                            error={!!errors?.description?.message}
                                            helperText={errors?.description?.message}

                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Extar Coin Percetage"
                                            variant="outlined"
                                            placeholder="Extra Coin Percentage"
                                            {...register("extra_coin")}
                                            error={!!errors?.extra_coin?.message}
                                            helperText={errors?.extra_coin?.message}

                                        />
                                    </Grid>

                                    <Grid item xs={12} sm={6}>
                                        <TextField type='file' accept="image/*" variant="outlined" id='badge-image' placeholder='image' onChange={handleImage} />
                                        <Badge anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }} >
                                            <Avatar src={image} sx={{ width: 100 }} />
                                        </Badge>
                                    </Grid>

                                </Grid>

                                <Stack direction="row" spacing={2} mt={3}>
                                    <Button variant='contained' type='submit'>Add Badge</Button>

                                    <Button variant="contained" color="error" onClick={handleClose}>
                                        Close
                                    </Button>
                                </Stack>

                            </form>
                        </Card>
                    </Box>
                </Modal>

                {/* <SnackBarUI state={snack} setState={setSnack} status={status} message={message} /> */}

            </Body>


        </>
    )
}

export default AddBadge
